// extracted by mini-css-extract-plugin
export default {"general":"Card_general__nmO2Y","button":"Card_button__Zb7H5","content":"Card_content__Mgdqr"};